/* AARON LEVINE site-wide scripts (loaded from layout/theme.liquid). */

/*
  Collection sort: on desktop, the theme's small "Sort by" dropdown becomes a "Sort" button that opens a panel:
  a SORT heading, then the options. Picking one sets the theme's own sort menu, so filtering and sorting keep working as before.
  SORT_OPTIONS sets the options shown, their labels and order; any others (Featured, dates, alphabetical, "Most relevant")
  are removed from every sort menu on the page, including the phone filter drawer. With no sort picked, the page keeps
  its own order (e.g. FW '26's color order) and the button just reads "Sort".
  "Newest" is re-ordered by published date on collection pages (see the collection template).
*/
(function () {
  var SORT_OPTIONS = [
    ['created-descending', 'Newest'],
    ['best-selling', 'Best selling'],
    ['price-ascending', 'Price, low to high'],
    ['price-descending', 'Price, high to low']
  ];
  var KEEP = SORT_OPTIONS.map(function (o) { return o[0]; });

  // Trim and relabel the theme's own sort menus (desktop and phone). The current choice is kept so the menu stays valid.
  function trimSelects() {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        var i = KEEP.indexOf(opt.value);
        if (i < 0) { if (!opt.selected) opt.remove(); return; }
        if (opt.textContent.trim() !== SORT_OPTIONS[i][1]) opt.textContent = SORT_OPTIONS[i][1];
      });
    });
  }

  function build() {
    trimSelects();
    var select = document.getElementById('SortBy');
    if (!select) return;
    var field = select.closest('.facet-filters__field');
    if (!field || field.querySelector('.al-sort')) return;

    var current = select.value;
    var match = SORT_OPTIONS.filter(function (o) { return o[0] === current; })[0];

    var wrap = document.createElement('div');
    wrap.className = 'al-sort';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'al-sort__button';
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = 'Sort' + (match ? ': <span>' + match[1] + '</span>' : '') + '<span class="al-sort__sign" aria-hidden="true">+</span>';
    var panel = document.createElement('div');
    panel.className = 'al-sort__panel';
    panel.hidden = true;
    panel.innerHTML = '<p class="al-sort__heading">Sort</p>';
    var list = document.createElement('ul');
    list.className = 'al-sort__list';

    SORT_OPTIONS.forEach(function (o) {
      if (!select.querySelector('option[value="' + o[0] + '"]')) return;
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = o[1];
      if (o[0] === current) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        select.value = o[0];
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        panel.hidden = true;
      });
      li.appendChild(b);
      list.appendChild(li);
    });
    panel.appendChild(list);

    button.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      button.setAttribute('aria-expanded', String(!panel.hidden));
      button.querySelector('.al-sort__sign').textContent = panel.hidden ? '+' : '–';
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target) && !panel.hidden) button.click();
    });

    wrap.appendChild(button);
    wrap.appendChild(panel);
    field.classList.add('al-sort-field');
    field.appendChild(wrap);
  }

  /*
    Color filter: colors listed A–Z (ignoring capitals), with a small swatch dot before each name.
    Add a color to SWATCHES (lowercase name: hex) when a new one is introduced; unknown names just show no dot.
    Group names (Blue, Green...) are included for when colors are grouped in the Search & Discovery app.
    HIDDEN_COLORS are left out of the Color filter for now (products not ready / no swatch yet); delete a name to bring it back.
  */
  var HIDDEN_COLORS = ['washed blue', 'washed green'];
  var SWATCHES = {
    'black': '#111', 'faded black': '#3a3a3a', 'washed black': '#2e2e2e', 'rinse black': '#222', 'vintage black': '#333',
    'navy': '#1f2a44', 'midnight navy': '#191f33', 'blue': '#7d9cc4', 'lightest blue': '#c9dcef', 'sky blue': '#a7c7e7',
    'sapphire': '#2b4c8c', 'denim': '#4a6489', 'midwash denim': '#5b7799', 'rinse': '#2c3a55', 'indigo': '#2f3b63', 'lilac': '#b9a6c9',
    'ash': '#b7b4ae', 'charcoal': '#3d3d3d', 'graphite': '#4a4a4a', 'gray': '#8a8a8a', 'grey': '#8a8a8a', 'slate': '#5d6670',
    'brown': '#6b4a33', 'chocolate': '#4a3022', 'espresso': '#3b2a20', 'rust': '#a0522d', 'dune': '#c2a27c',
    'red': '#a8322d', 'washed red': '#b5524a', 'cherry': '#a32630', 'coral': '#e2725b', 'flamingo': '#f19aa4', 'pink': '#e8a1b0',
    'green': '#55664a', 'black olive': '#3b3c2e', 'olive': '#6b6b3a', 'kelp': '#5b6142', 'sage': '#9caf88',
    'khaki': '#c3b091', 'tan': '#c8a97e', 'butter': '#f2e2a4', 'yellow': '#f0d36b', 'sunshine yellow': '#f2c94c',
    'oatmeal': '#e3d5bf', 'bone': '#e8e0cf', 'cream': '#f2ecdc', 'natural': '#ede4d3', 'white': '#fff'
  };
  function colorName(li) {
    var l = li.querySelector('.facet-checkbox__text-label');
    return l ? l.textContent.trim().toLowerCase() : '';
  }
  function swatches() {
    document.querySelectorAll('details[id*="option.color"] .mobile-facets__list, details[id*="option.color"] .facets__list').forEach(function (list) {
      var items = Array.prototype.filter.call(list.children, function (li) { return li.tagName === 'LI'; });
      var sorted = items.slice().sort(function (a, b) { return colorName(a).localeCompare(colorName(b)); });
      if (sorted.some(function (li, i) { return li !== items[i]; })) sorted.forEach(function (li) { list.appendChild(li); });
    });
    document.querySelectorAll('details[id*="option.color"] .facet-checkbox__text-label').forEach(function (label) {
      var name = label.textContent.trim().toLowerCase();
      if (HIDDEN_COLORS.indexOf(name) > -1) {
        var item = label.closest('li');
        if (item && !item.hidden) item.hidden = true;
        return;
      }
      if (label.previousElementSibling && label.previousElementSibling.classList.contains('al-swatch')) return;
      var hex = SWATCHES[name];
      if (!hex) return;
      var dot = document.createElement('span');
      dot.className = 'al-swatch';
      dot.style.background = hex;
      label.before(dot);
    });
  }

  function start() {
    build();
    swatches();
    // The theme redraws the filter bar after each filter or sort, so rebuild when that happens.
    new MutationObserver(function () { build(); swatches(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Product details by color: a description line marked class="al-c al-c-<color>" (e.g. al-c-brown-tweed) shows only while that
  color is picked, so each color can list its own fabric. The " ON <COLOR>" text inside a line (class al-c-on) is for when this
  script can't run, so the lines still make sense together; it's hidden otherwise.
*/
(function () {
  var style = document.createElement('style');
  style.textContent = '.al-c-ready .al-c-on { display: none; } .al-c-ready .al-c[hidden] { display: none; }';
  document.head.appendChild(style);
  function slug(s) { return (s || '').toLowerCase().trim().replace(/\s+/g, '-'); }
  function picked() {
    var r = document.querySelector('input[type="radio"][name^="Color-"]:checked');
    if (r) return r.value;
    var s = document.querySelector('select[name="options[Color]"]');
    return s ? s.value : '';
  }
  function update() {
    var lines = document.querySelectorAll('.al-c');
    if (!lines.length) return;
    var c = slug(picked());
    if (!c) return;
    document.documentElement.classList.add('al-c-ready');
    lines.forEach(function (li) {
      var show = li.classList.contains('al-c-' + c);
      if (li.hidden === show) li.hidden = !show;
    });
  }
  function start() {
    update();
    document.addEventListener('change', update);
    // The theme redraws the product section when a color is picked, so check again whenever the page changes.
    new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Collection collage (the collection template's split layout with several images, e.g. Accessories): on desktop it scrolls with
  the page until its bottom reaches the bottom of the screen, then stays put while the products keep scrolling.
*/
(function () {
  function pin() {
    var c = document.querySelector('#product-grid .al-collage');
    if (!c) return;
    var wide = window.innerWidth >= 990;
    var pos = wide ? 'sticky' : '';
    var top = wide ? Math.min(88, window.innerHeight - c.offsetHeight) + 'px' : '';
    if (c.style.position !== pos) c.style.position = pos;
    if (c.style.top !== top) c.style.top = top;
  }
  function start() {
    pin();
    window.addEventListener('resize', pin);
    new MutationObserver(pin).observe(document.getElementById('ProductGridContainer') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
